module.exports = __webpack_public_path__ + "img/money.9fc5324a.svg";